import React, {useContext, useEffect,useState} from 'react';
import {ModelContext} from '../../metadata/ModelSource';
import {getRiskCoverages} from '../../../api/applicationAPI';
import {Row, Col, Divider} from 'antd';
import {formatMoneyAmount, formatMoneyAmountNoDecimal} from '../../../utils/formatUtils';
import {GlobalStateContext} from '../../../context/GlobalStateProvider';
import {ErrorSink} from '../../ErrorSink';

export const CoverageTableSummary = ({lineCd}) => {
  //depending on the lineCd call coverageList api and loop through the api to show the coverages

  const applicationModel = useContext(ModelContext);
  const { isDesktop } = useContext(GlobalStateContext);
  const [activeCoverages, setActiveCoverages] = useState([]);

  const columnHeaders = ['Coverages', 'Limit','Premium'];

  useEffect(  () =>{
    const getActiveCoverages = async (systemId,lineCd,riskNum) => {
      try{
        const response = await getRiskCoverages(systemId,lineCd,riskNum);
        setActiveCoverages(response.coverages);
      }
      catch(err){
        /*
        TODO: what to do if coverage api fails? For now nothing and no coverage table summary is rendered
         */
      }
    }
    /*
      TODO: the risk number should be made generic if this component is used for products that have more than one risk
    */
      getActiveCoverages(applicationModel.data.systemId,lineCd,1);
    },[])

  const CoverageLimits = ({limits}) => {
    if(limits === undefined)
      return null

    if(limits.length === 1)
      return `$${formatMoneyAmountNoDecimal(limits[0].value)}`;

      let limitsArray = limits.map(item =>  `$${formatMoneyAmountNoDecimal(item.value)}`);
      limitsArray = limitsArray.join('/');
      return limitsArray;
  }

  const CoveragePremium = ({coverage}) => {
    if(coverage.includedInd)
      return 'Included';
    return formatMoneyAmount(coverage.writtenPremiumAmt);
  }

  const DesktopTable = () => {
    return (
        <div className={'coverage-table-summary'}>
          <Row id={'coverage-summary-table-header'} gutter={[8, 0]} >
            <Col span={14}>{columnHeaders[0]}</Col>
            <Col className={'limit-col'} span={4}>{columnHeaders[1]}</Col>
            <Col className={'premium-col'}span={4}>{columnHeaders[2]}</Col>
          </Row>
          <Divider/>
          {activeCoverages.map((coverage) => {
            return (<Row  gutter={[8, 32]} >
              <Col className={'description-col'} span={14}>{coverage.description}</Col>
              <Col className={'limit-col'} span={4}><CoverageLimits limits={coverage.limits}></CoverageLimits></Col>
              <Col className={'premium-col'} span={4}><CoveragePremium coverage={coverage}></CoveragePremium></Col>
            </Row>)
          })}
        </div>
    )
  }

  const MobileTable = () => {
    return (
        <div className={'coverage-table-summary mobile'}>
          {activeCoverages.map((coverage) => {
            return (<Row className={'coverage-detail-row'}>
              <Row><Col></Col> <Col className={'description-col'}>{coverage.description}</Col></Row>
              <Row  className={'limit-row'}><Col span={12} >{columnHeaders[1]}</Col><Col className={'limit-col'} span={12}><CoverageLimits limits={coverage.limits}></CoverageLimits></Col></Row>
              <Row  className={'premium-row'}> <Col span={12}>{columnHeaders[2]}</Col> <Col className={'premium-col'} span={12}><CoveragePremium coverage={coverage}></CoveragePremium></Col></Row>
            </Row>)
          })}
        </div>
    )
  }

  return (isDesktop ? <DesktopTable/> : <MobileTable/>);

}


